export type { PageRoleBoundaryProps } from './PageRoleBoundary';

export { default as PageRoleBoundary } from './PageRoleBoundary';
